let info = {
    title: 'AM Dev',
};

export default info;